import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { getUniqueKey, isMobile } from '../../../../utils/HTMLutils'
import './TextEditorTitleChoser.scss'
const rootClassName = 'text-editor-title-choser'

export default function TextEditorTitleChoser(props) {
  const [id] = useState(getUniqueKey())
  const [previousSelection, setPreviousSelection] = useState({})
  useEffect(() => {
    if (props.opened) {
      const {
        anchorNode,
        anchorOffset,
        focusNode,
        focusOffset
      } = window.getSelection()
      setPreviousSelection({ anchorNode, anchorOffset, focusNode, focusOffset })
      const el = document.querySelector(`#${id} button`)
      if (el) {
        el.focus()
        if (isMobile()) {
          el.blur()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened])

  const handleChange = (text) => {
    window
      .getSelection()
      .setBaseAndExtent(
        previousSelection.anchorNode,
        previousSelection.anchorOffset,
        previousSelection.focusNode,
        previousSelection.focusOffset
      )
    if (typeof props.onChange === 'function') {
      props.onChange(text)
    }
  }
  return (
    <div className={rootClassName} id={id}>
      <button onClick={() => handleChange('H1')}>
        <h1>Título</h1>
      </button>
      <button onClick={() => handleChange('H6')}>
        <h6>Texto</h6>
      </button>
    </div>
  )
}

TextEditorTitleChoser.propTypes = {
  onChange: PropTypes.func,
  opened: PropTypes.bool
}

TextEditorTitleChoser.defaultProps = {
  onChange: () => {}
}
